/* tslint:disable */
/* eslint-disable */
/* @relayHash f6f9f9a35601a916e9157c51ca4766d7 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs as  } from "relay-runtime";
export type InviteRouteQueryVariables = {};
export type InviteRouteQueryResponse = {
    readonly settings: {
        readonly " $fragmentRefs": FragmentRefs<"InviteCompleteFormContainer_settings" | "SuccessContainer_settings">;
    };
};
export type InviteRouteQuery = {
    readonly response: InviteRouteQueryResponse;
    readonly variables: InviteRouteQueryVariables;
};



/*
query InviteRouteQuery {
  settings {
    ...InviteCompleteFormContainer_settings
    ...SuccessContainer_settings
    id
  }
}

fragment InviteCompleteFormContainer_settings on Settings {
  organization {
    name
  }
}

fragment SuccessContainer_settings on Settings {
  organization {
    name
    url
  }
}
*/

const node: ConcreteRequest = {
    "fragment": {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "InviteRouteQuery",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "Settings",
                "kind": "LinkedField",
                "name": "settings",
                "plural": false,
                "selections": [
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "InviteCompleteFormContainer_settings"
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SuccessContainer_settings"
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Query",
        "abstractKey": null
    },
    "kind": "Request",
    "operation": {
        "argumentDefinitions": [],
        "kind": "Operation",
        "name": "InviteRouteQuery",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "Settings",
                "kind": "LinkedField",
                "name": "settings",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Organization",
                        "kind": "LinkedField",
                        "name": "organization",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "name",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ]
    },
    "params": {
        "id": "f6f9f9a35601a916e9157c51ca4766d7",
        "metadata": {},
        "name": "InviteRouteQuery",
        "operationKind": "query",
        "text": null
    }
} as any;
(node as any).hash = 'db63f815e30e55a9371a5b8f62688890';
export default node;
